import { defineComponent as p, ref as f, inject as m, createElementBlock as l, openBlock as u, mergeProps as _, unref as e, renderSlot as b } from "vue";
import s from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/TabContent/tab-content.js";
import { TabsProvideKey as y } from "./common.js";
import { useOUIAProps as h } from "../../helpers/ouia.js";
const P = ["hidden"], S = /* @__PURE__ */ p({
  name: "PfTabContent",
  __name: "TabContent",
  props: {
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(a, { expose: r }) {
    var t;
    const o = a, i = h({ id: o.ouiaId, safe: o.ouiaSafe }), n = f(!1), d = (t = m(y, void 0)) == null ? void 0 : t.secondary;
    return r({
      hidden: n
    }), (c, v) => (u(), l("section", _(e(i), {
      class: [e(s).tabContent, {
        [e(s).modifiers.secondary]: e(d)
      }],
      role: "tabpanel",
      hidden: n.value || void 0,
      tabindex: "0"
    }), [
      b(c.$slots, "default")
    ], 16, P));
  }
});
export {
  S as default
};
